module.exports = import("https://cdn.jsdelivr.net/npm/hls.js@latest/dist/hls.min.js");;